import { render, staticRenderFns } from "./MobileAppNoticeBanner.vue?vue&type=template&id=42f01a1b&scoped=true&"
import script from "./MobileAppNoticeBanner.vue?vue&type=script&lang=js&"
export * from "./MobileAppNoticeBanner.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppNoticeBanner.vue?vue&type=style&index=0&id=42f01a1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f01a1b",
  null
  
)

export default component.exports